module.exports = __webpack_public_path__ + "static/media/placeholder.0796313a.svg";